import React, { FC } from 'react';
import myImage from "./1 Futuresend Logo.png";


interface ILogoProps {
	width?: number;
	height?: number;
}
const LogoLight: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img width={height !== 854 && !!height ? height * (2155 / 550) : width} src={myImage} />
	);
};

export default LogoLight;
